import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { TypedAttributes, TypedElement } from '../htmlElementTyped';

export interface UpdatedAtAttributes extends TypedAttributes {
  date: string;
  index?: string;
}

export const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
export const daysToShowUpdated = 30; // Updates less than x days old will be highlighted

export class UpdatedAt extends TypedElement<UpdatedAtAttributes> {
  constructor() {
    super();
  }

  render = () => {
    const { date, index } = this.typedAttributes;

    if (date) {
      const updateDate = new Date(parseInt(date)).getTime();
      const currentDate = new Date().getTime();
      const dayDiff = Math.floor((currentDate - updateDate) / oneDay);

      if (dayDiff <= daysToShowUpdated) {
        this.innerHTML = '';
        this.append(
          <span
            className="updated"
            style={`--animation-offset: ${parseInt(index || '0') * 100}ms;`}
          >
            <div className="sparkle">✨</div>
            <span className="updatedText">
              {dayDiff === 0
                ? 'Updated Today!'
                : `Updated ${dayDiff} day${dayDiff === 1 ? '' : 's'} ago!`}
            </span>
          </span>,
        );
      }
    }
  };

  connectedCallback() {
    void this.render();
  }
}
